@if (visibleCompetencyNodes && visibleCompetencyNodes.length) {
  <div class="list-group">
    @for (competencyNode of visibleCompetencyNodes; track competencyNode) {
      <competency-node [node]="competencyNode" (onCompetencyClicked)="competencyClicked($event)"></competency-node>
    }
  </div>
}
